import React, { Component } from 'react';
import cx from 'classnames';
import ViewMainMedia from './ViewMainMedia/ViewMainMedia';
import TourControls from './TourControls/TourControls';
import Footer from './Footer/Footer';
import TrialTierBanner from './TrialTierBanner/TrialTierBanner';
import MiniMap from './MiniMap/MiniMap';
import CookieBanner from './CookieBanner/CookieBanner';
import TourStopMediaBox from './TourStopMediaBox/TourStopMediaBox';
import ShareModal from '../../Modal/ShareModal/ShareModal';
import mapInterface from '../../../mapboxgl/mapInterface';
import Favicon from '../../Media/Favicon/Favicon';
import InactiveAccount from '../../Pages/InactiveAccount/InactiveAccount';
import Drawer from '../../Drawer/Drawer';
import StopGallery from '../../StopGallery/StopGallery';
import FormModal from '../../Modal/FormModal/FormModal';
import './ViewWrapper.scss';
import unmuteIOSAudio from '../../../utils/unmuteIOSAudio';
import Button from '../../Buttons/Button';
import WelcomePopUp from '../../WelcomePopUp/WelcomePopUp';
import {
  customGaEvent,
  gaInit,
  PublicGaEvents,
  updateConsent,
  consentGranted,
} from '../../../utils/ga';
import { getCookie, setCookie, cookies } from '../../../utils/cookies';
import { addNewScript } from 'utils/htmlHelpers';
import adaFocusAddHelper from '../../../utils/adaFocusAddHelper';
import './ViewWrapper.scss';
// featureFlag
import { FlagContext } from 'featureFlags/FeatureFlagProvider';
import { addGtagConsentListener } from 'utils/postMessage';
import { hasSearchParam, searchParams } from 'utils/searchParams';
import { handleIosSafariOrientationSwap } from 'components/AFrame/components/AFrameShared';
import { isIphone, isSafari } from 'utils/userAgentHelpers';

class ViewWrapper extends Component {
  // featureFlag
  static contextType = FlagContext;
  constructor(props) {
    super(props);
    this.state = {
      index: props.activeStop - 1,
      viewC3DDescription: false,
      showShare: false,
      radarPos: null,
      showCookieBanner: false,
      yPosition: window.innerHeight,
      restPosition: false,
      innerWidth: window.innerWidth,
      isMobile: window.innerWidth < 1025,
      panoHasKeyboardControl: true,
      shouldShowForm: false,
      repeatFormDisplay: false,
      displayOnStopId: '',
      hasShownForm: false,
      formDisplayed: false,
      formId: '',
      showPanoControls: false,
      panoControlsDismissed: false,
      previewExitPath: `/home`,
    };
  }

  componentDidMount() {
    const {
      tours = {},
      tourId,
      publicTour,
      fetchPublicTour,
      fetchPublicTourLanguages,
      switchMapView,
      history = {},
      match = {},
    } = this.props;
    // featureFlag
    const { checkFlag } = this.context;
    const multiLangFlag =
      typeof checkFlag === 'function' && checkFlag('multi-lang');
    const currentTour = tours[tourId];
    addGtagConsentListener(() => {
      this.setState({ showCookieBanner: false });
    });

    this.fetchPreviewData();
    // required for audio hotspots on ios
    unmuteIOSAudio();

    if (isIphone() && isSafari()) {
      window.addEventListener('orientationchange', handleIosSafariOrientationSwap);
    }

    if (publicTour && !currentTour) {
      try {
        fetchPublicTour(tourId, match.params).catch(e => {
          if (e.message === 'Expired') {
            history.push('/error/tourexpired');
          }
        });
        multiLangFlag && fetchPublicTourLanguages(tourId);
      } catch (error) {
        console.error(error);
      }
    }

    if (hasSearchParam(searchParams.MAP_VIEW)) {
      // on mount, check if query params include map default
      switchMapView({
        miniMapView: 'pano',
      });
    }

    if (publicTour) {
      // add document events for keydown & click to toggle focus outline on & off
      adaFocusAddHelper();
      window.addEventListener('keyup', () => this.togglePanoControls(true));
      if (tourId === 'Hk_MW9xAM') {
        const script = document.createElement('script');
        script.innerHTML = `
          (function(a,b,c,d,e,f,g) {
            a[e] = a[e] || function() {(a[e].q = a[e].q || []).push(arguments)};f=b.createElement(c);
            g=b.getElementsByTagName(c)
            [0];f.async=1;f.src=d+"/cbe/cbe.js";g.parentNode.insertBefore(f,g);
            })(window,document,"script","https://cbe.capturehighered.net","_cbe");
            _cbe("create","0042262d");
            _cbe("log","pageview");
        `;
        script.async = true;
        document.head.appendChild(script);
      }
    }
    window?.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      stops,
      tours,
      tourId,
      publicTour,
      previewTour,
      fetchPublicTour,
      miniMapView,
      analyticsMeasurementId,
      analyticsContainerId,
      history,
      activeStop,
      aid,
      customScript,
      match,
    } = this.props;
    const { params = {} } = match;
    const {
      index,
      showCookieBanner,
      shouldShowForm,
      hasShownForm,
    } = this.state;
    const currentTour = tours[tourId];
    const tourStops = this.getTourStops();
    const currentStop = tourStops[index];
    const startButton = document.querySelector('.start-tour');

    if (publicTour && prevProps.match?.params?.lang !== params?.lang) {
      try {
        fetchPublicTour(tourId, match.params);
      } catch (error) {
        console.error(error);
      }
    }

    if (previewTour && prevProps.match?.params?.lang !== params?.lang) {
      this.fetchPreviewData();
    }

    if (
      publicTour &&
      currentTour &&
      tours[tourId] !== prevProps.tours[tourId]
    ) {
      this.setDocumentTitle(currentTour.name);
    }

    if (publicTour && !prevProps.customScript && customScript) {
      addNewScript(customScript);
    }

    if (prevProps.activeStop !== activeStop) {
      const locationState = history?.location?.state || {};
      const { number, ...rest } = locationState;
      this.updateStopNumber({ number: number || activeStop - 1, ...rest });
      this.getPublicTourStopInfo();
    }

    if (publicTour && !prevProps.tours[tourId] && currentTour) {
      this.setDocumentTitle(currentTour.name);
      const stopName = currentStop.name;
      const stopNumber = activeStop;
      gaInit({
        accountId: aid,
        analyticsContainerId,
        clientGA4Id: analyticsMeasurementId,
        stopName,
        stopNumber,
        tourId,
        tourName: currentTour.name,
      });
      const cookiesAccepted = getCookie(cookies.ACCEPTED_COOKIES_POLICY);
      const cookiePolicyHide = hasSearchParam(searchParams.COOKIE_POLICY_HIDE);
      if (
        currentTour.cookieEnabled && !cookiePolicyHide
      ) {
        cookiesAccepted === ''
          ? this.setState({ showCookieBanner: true })
          : updateConsent(consentGranted);
      }
    }

    if (miniMapView !== prevProps.miniMapView) {
      // pans to stop marker when swapping between minimap and main view
      if (currentTour) {
        const { lng, lat } = stops[tours[tourId].stopIds[index]];
        mapInterface
          .getMap()
          .panTo([lng, lat], { duration: 1000, animate: true });
      }
    }
    if (showCookieBanner !== prevState.showCookieBanner && startButton) {
      this.toggleStartButton(startButton);
    }

    // ga form event
    if (
      prevState.shouldShowForm !== shouldShowForm &&
      prevState.hasShownForm !== hasShownForm
    ) {
      customGaEvent({
        action: PublicGaEvents.FORM_AUTO_OPEN,
        label: currentStop.name,
      });
    }
    // send initial customGaEvent on tour load
    if (!prevProps.tours[prevProps.tourId] && currentTour) {
      this.getPublicTourStopInfo();
      customGaEvent({
        action: PublicGaEvents.TOUR_VIEW,
        label: currentStop.name,
      });
      customGaEvent({
        action: PublicGaEvents.STOP_VIEW,
        label: currentStop.name,
      });
    }

    this.handleFormState(prevState, currentTour, currentStop);
    this.handle404Error(currentTour);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { match } = this.props;
    const { accountPermissions = {} } = nextProps;
    if (match.params.lang !== nextProps.match.params.lang) return true;
    if (!Object.keys(nextProps.tours).length) {
      // prevent render until tours object has been populated via SAVE_ALL_TOUR_ACCOUNT_DATA or SAVE_PUBLIC_TOUR
      return false;
    }
    if (!Object.keys(accountPermissions).length) {
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    const { miniMapView, switchMapView } = this.props;
    miniMapView === 'pano' && switchMapView({ miniMapView: 'map' });

    if (isIphone() && isSafari()) {
      window.removeEventListener('orientationchange', handleIosSafariOrientationSwap);
    }

    window.removeEventListener('keyup', this.togglePanoControls);
    window?.removeEventListener('resize', this.handleResize);

    this.clearComponentTimeout('formDisplayTimer');
  }

  clearComponentTimeout(timerName) {
    if (this[timerName]) {
      clearTimeout(this[timerName]);
      this[timerName] = 0;
    }
  }

  handle404Error = currentTour => {
    const { history, publicTour, previewTour } = this.props;
    if (!previewTour && !publicTour && !currentTour) {
      // if tourId in URL is incorrect & not found in user tours obj, redirect to 404 error page
      history.push({
        pathname: '/error/404',
        state: { errorType: 'tour' },
      });
    }
  };

  handleFormState = (prevState, currentTour, currentStop) => {
    const {
      displayOnStopId,
      repeatFormDisplay,
      formDisplayed,
      showCookieBanner,
      shouldShowForm,
      hasShownForm,
    } = this.state;
    const hasForms =
      currentTour && Object.keys(currentTour.forms || {}).length > 0;
    const popupModal = document.querySelector('#welcome-modal');
    const showFormOnStop = currentStop?.id === displayOnStopId;

    if (hasForms) {
      const [currentFormId] = Object.keys(currentTour.forms);
      if (prevState.formId !== currentFormId) {
        const {
          formDisplayed,
          repeatFormDisplay,
          displayOnStopId,
        } = currentTour.forms[currentFormId];

        this.setFormStates({
          formDisplayed,
          formId: currentFormId,
          repeatFormDisplay,
          displayOnStopId,
        });
      }
    }

    if (
      showFormOnStop &&
      !shouldShowForm &&
      !hasShownForm &&
      formDisplayed &&
      !showCookieBanner &&
      !popupModal
    ) {
      this.setState({ shouldShowForm: true, hasShownForm: true });
    }
    if (
      formDisplayed &&
      repeatFormDisplay &&
      currentStop?.id !== displayOnStopId &&
      hasShownForm
    ) {
      this.setState({ shouldShowForm: false, hasShownForm: false });
    }
  };

  fetchPreviewData = () => {
    const {
      history,
      tourId,
      fetchPreviewTour,
      fetchAvailableLanguages,
      match,
      previewTour,
    } = this.props;
    const { checkFlag } = this.context;

    if (previewTour) {
      this.setState({
        previewExitPath: history.location.state?.previewExitPath || '/home',
      });
    }

    if (previewTour) {
      const multiLangFlag =
        typeof checkFlag === 'function' && checkFlag('multi-lang');
      fetchPreviewTour(tourId, match?.params?.lang);
      multiLangFlag && fetchAvailableLanguages(tourId);
    }
  };

  setFormStates = dataObj => {
    this.setState({ ...dataObj });
  };

  setDocumentTitle = tourName => {
    document.title = tourName;
  };

  toggleC3DDescription = () => {
    this.setState(prevState => ({
      viewC3DDescription: !prevState.viewC3DDescription,
    }));
  };

  setYPosition = y => {
    const getPreviewPosition = y =>
      this.props.previewTour && y === 0 ? 48 : y;

    if (!isNaN(y)) {
      this.setState({ yPosition: getPreviewPosition(y) });
      return null;
    }

    const { yPosition } = this.state;
    const yPos =
      yPosition <= window.innerHeight / 2
        ? window.innerHeight
        : getPreviewPosition(0);

    this.setState({
      yPosition: yPos,
    });
  };

  setRestPosition = restPosition => {
    this.setState({ restPosition });
  };

  changeStop = stopData => {
    const { stopNum, stopName, origin, defaultPos, stopId } = stopData;
    const { tours, tourId, history = {}, baseUrl } = this.props;
    const currentTour = tours[tourId];
    const maxStopNum = tours[tourId].stopIds.length;

    let stopNumber = stopNum;

    if (stopId) {
      stopNumber = currentTour.tourStops.findIndex(stop => stop.id === stopId);
    }
    if (stopNumber === maxStopNum) {
      stopNumber = 0;
    } else if (stopNum < 0) {
      stopNumber = maxStopNum - 1;
    }
    const newStopPathname = `${baseUrl}/${stopNumber + 1}`;
    if (newStopPathname === history.location?.pathname) return false;
    history.push({
      pathname: newStopPathname,
      state: {
        stopName,
        origin,
        defaultPos,
        number: stopNumber,
      },
    });
  };

  updateStopNumber = ({ number, stopName, origin, defaultPos = 0 }) => {
    const { history, baseUrl, stops, tours, tourId } = this.props;
    const stopIds = tours[tourId].stopIds;
    const updatedUrl = `${baseUrl}/${number + 1}`;

    this.setState({ index: number, radarPos: defaultPos }, () => {
      const id = stopIds.find((_, i) => i === number);
      const { name } = stops[id];
      stopName = stopName || name;

      // fire GA events
      if (origin) {
        customGaEvent({
          action: `Stop ${origin}`,
          label: stopName,
        });
        customGaEvent({
          action: PublicGaEvents.STOP_VIEW,
          label: stopName,
        });
      }

      if (history.location.pathname !== updatedUrl) {
        history.push(updatedUrl);
      }
    });
  };

  toggleShareModal = () => {
    const { baseUrl } = this.props;
    const { index } = this.state;
    this.setState(
      ({ showShare }) => ({ showShare: !showShare }),
      () => {
        this.state.showShare &&
          customGaEvent({
            action: PublicGaEvents.SHARE_TOUR,
            label: `${baseUrl}/${index + 1}`,
          });
      }
    );
  };

  checkLogoURL = () => {
    const { tours, tourId } = this.props;
    const { logoURL } = tours[tourId].styles;
    if (logoURL && logoURL.includes('http')) {
      return logoURL;
    }
    return `https://${logoURL}`;
  };

  getPanoRotation = (evt, camera) => {
    const {
      detail: { name },
    } = evt;
    if (name === 'rotation') {
      const { y } = camera.getAttribute('rotation');
      if (y !== this.state.radarPos) {
        this.setState({ radarPos: y });
      }
    }
  };

  hideCookieBanner = () => {
    setCookie(cookies.ACCEPTED_COOKIES_POLICY, true, 365);
    updateConsent(consentGranted);
    customGaEvent({ action: 'Accept Cookies' });
    this.setState({
      showCookieBanner: false,
    });
  };

  togglePanoKeyboardControl = () => {
    this.setState(state => {
      return { panoHasKeyboardControl: !state.panoHasKeyboardControl };
    });
  };

  toggleStartButton = startButton => {
    const { showCookieBanner } = this.state;
    showCookieBanner && startButton
      ? startButton.setAttribute('disabled', 'disabled')
      : startButton.removeAttribute('disabled');
  };

  toggleFormDisplay = () => {
    const { index, shouldShowForm } = this.state;
    const currentStop = this.getTourStops()[index];
    customGaEvent(
      `${shouldShowForm ? PublicGaEvents.FORM_CLOSED : PublicGaEvents.FORM_BUTTON}`,
      {
        label: currentStop.name,
      }
    );
    this.setState({ shouldShowForm: !shouldShowForm });
  };

  togglePanoControls = bool => {
    const { panoControlsDismissed } = this.state;
    // if false, keep controls hidden
    if (!bool) {
      this.setState({ panoControlsDismissed: true });
    }

    // if controls have not been dismissed, show controls
    if (!panoControlsDismissed) {
      this.setState({
        showPanoControls: bool,
      });
    }
  };

  createShareUrl = () => {
    const { tourId } = this.props;
    const { shareView, shareLang, index } = this.state;
    const viewParam = shareView === 'map' ? '?mv' : '';
    const lang = shareLang ? `${shareLang}/` : '';
    return `${window.location.origin}/${lang}share/${tourId}/stop/${index +
      1}${viewParam}`;
  };

  getTourStops = () => {
    const { tours, tourId } = this.props;
    const currentTour = tours[tourId];
    let tourStops = [];
    if (currentTour) {
      tourStops = currentTour.tourStops || [];
    }
    return tourStops;
  };

  getPublicTourStopInfo() {
    const { match, tours, setPublicTourStopInfo } = this.props;
    const { id, activestop } = match.params;
    const stopName = tours[id]?.tourStops[activestop - 1].name;

    setPublicTourStopInfo(stopName, activestop);
  }

  handleResize = () => {
    this.setState({
      isMobile: window.innerWidth < 1025,
    });
  };

  render() {
    const {
      index,
      isMobile,
      panoHasKeyboardControl,
      radarPos,
      restPosition,
      shouldShowForm,
      showCookieBanner,
      showShare,
      viewC3DDescription,
      yPosition,
      showPanoControls,
      previewExitPath,
    } = this.state;
    const {
      active,
      audio,
      hideStopDescription,
      history,
      images,
      isMainMediaPlaying,
      location,
      mapboxToken,
      miniMapView,
      panos,
      publicTour,
      showStopDescription,
      stopDescriptionMinimized,
      stops,
      switchMapView,
      tier,
      toggleMainMediaStatus,
      tourId,
      aid,
      tours = {},
      videos,
      sendHubspotEvent,
      accountPermissions = {},
      tourLanguages = [],
      previewTour,
      captureHigherEdTrackingId,
    } = this.props;

    const currentTour = tours[tourId];
    if (!currentTour) return null;
    const tourStops = this.getTourStops();
    const starter =
      (tier === 'starter' || tier === 'trial') && publicTour ? 'starter' : '';
    const currentStop = tourStops[index];

    const formId =
      currentTour &&
      Object.keys(currentTour.forms || {}).length > 0 &&
      Object.keys(currentTour.forms);

    const currentForm =
      currentTour && currentTour.forms && currentTour.forms[formId];

    if (!active) {
      return <InactiveAccount hideBackButton />;
    }

    const stopNumber = index + 1;

    const shareModal = (
      <ShareModal
        key="share-modal"
        shareUrl={`${window.location.origin}/share/${tourId}/stop/${stopNumber}`}
        stopNumber={stopNumber}
        embed
        closeModal={this.toggleShareModal}
        tourId={tourId}
        tourName={currentTour && currentTour.name}
        published
        uptoDate={publicTour ? true : currentTour && currentTour.uptoDate} // if share URL show tour as uptoDate, otherwise use the uptoDate props attached to tour
        isOpen={showShare}
        history={history}
        aid={aid}
        sendHubspotEvent={sendHubspotEvent}
      />
    );

    const viewWrapperClasses = cx({
      public: publicTour,
      minimap: miniMapView === 'map',
    });

    const shouldRenderForm = currentForm && accountPermissions.tourforms;
    const shouldRenderFormButton =
      currentForm && currentForm.formDisplayed && accountPermissions.tourforms;

    return (
      <div id="view-wrapper" className={viewWrapperClasses}>
        {currentTour && (
          <React.Fragment>
            {publicTour && showCookieBanner && (
              <CookieBanner
                showCookieBanner={showCookieBanner}
                acceptCookiePolicy={this.hideCookieBanner}
              />
            )}
            {currentTour.displayPopUp && (
              <WelcomePopUp
                tour={currentTour}
                tier={tier}
                videos={videos}
                captureHigherEdTrackingId={captureHigherEdTrackingId}
              />
            )}
            <Favicon faviconId={currentTour.styles.faviconId} />
            <ViewMainMedia
              key="main-media"
              history={this.props.history}
              miniMapView={miniMapView}
              tourStops={tourStops}
              currentTour={currentTour}
              currentStop={currentStop}
              activeStop={index}
              tier={tier}
              publicTour={publicTour}
              checkLogoURL={this.checkLogoURL}
              toggleShareModal={this.toggleShareModal}
              switchMapView={switchMapView}
              changeStop={this.changeStop}
              allStops={stops}
              getPanoRotation={this.getPanoRotation}
              radarPos={radarPos}
              path={location.pathname}
              mapToken={mapboxToken}
              setYPosition={this.setYPosition}
              images={images}
              panos={panos}
              panoHasKeyboardControl={panoHasKeyboardControl}
              stopDescriptionMinimized={stopDescriptionMinimized}
              toggleMainMediaStatus={toggleMainMediaStatus}
              isMainMediaPlaying={isMainMediaPlaying}
              showPanoControls={showPanoControls}
              togglePanoControls={this.togglePanoControls}
              tourId={tourId}
              aid={aid}
              previewTour={previewTour}
              accountPermissions={accountPermissions}
              captureHigherEdTrackingId={captureHigherEdTrackingId}
            />
            {previewTour && (
              <Button
                data-cy="preview-exit-btn"
                className="preview-exit-btn"
                handleClick={() => history.push(previewExitPath)}
              >
                Exit Preview
              </Button>
            )}
            {shouldRenderFormButton && shouldRenderForm && (
              <FormModal
                currentTour={currentTour}
                currentForm={currentForm}
                openModal={this.toggleFormDisplay}
                isOpen={shouldShowForm}
                closeModal={this.toggleFormDisplay}
                shouldShowForm={shouldShowForm}
                publicTour
              />
            )}
            <div className={`pano-info-wrapper ${starter}`}>
              {currentTour.showMiniMap !== false && (
                <MiniMap
                  tourId={tourId}
                  aid={aid}
                  tourName={currentTour.name}
                  tourPublished={currentTour.published}
                  allStops={stops}
                  stops={tourStops}
                  panos={panos}
                  activeStop={index}
                  changeStop={this.changeStop}
                  switchMapView={switchMapView}
                  miniMapView={miniMapView}
                  mainMediaType={currentStop?.mainMediaType}
                  primaryColor={currentTour.styles.primaryColor}
                  tourData={currentTour}
                  checkLogoURL={this.checkLogoURL}
                  closeShareModal={this.toggleShareModal}
                  radarPos={radarPos}
                  getPanoRotation={this.getPanoRotation}
                  path={location.pathname}
                  mapToken={mapboxToken}
                />
              )}
              <TourControls
                thumbnailList={tourStops}
                activeStop={index}
                handleChange={this.changeStop}
                tourStops={tourStops}
                miniMapView={miniMapView}
                handleTranslateDrawer={this.handleTranslateDrawer}
                setYPosition={this.setYPosition}
                tourName={currentTour.name}
                tier={tier}
                restPosition={restPosition}
                primaryColor={currentTour.styles.primaryColor}
              />
              <TourStopMediaBox
                activeStop={index}
                autoPlayAudio={currentStop?.autoPlayAudio}
                hideStopDescription={hideStopDescription}
                isMainMediaPlaying={isMainMediaPlaying}
                panoId={currentStop?.panoId}
                primaryColor={currentTour.styles.primaryColor}
                showStopDescription={showStopDescription}
                stopAudio={currentStop?.audio.map(id => audio[id])}
                stopDescription={currentStop?.description}
                stopDescriptionMinimized={stopDescriptionMinimized}
                stopImages={currentStop?.images.map(id => images[id])}
                stopName={currentStop?.name}
                stopVideos={currentStop?.videos.map(id => videos[id])}
                toggleMainMediaStatus={toggleMainMediaStatus}
                togglePanoKeyboardControl={this.togglePanoKeyboardControl}
                tourId={tourId}
                tourName={currentTour.name}
                aid={aid}
                previewTour={previewTour}
                hasLanguages={tourLanguages.length > 1}
              />
            </div>
            <Drawer
              primaryColor={currentTour && currentTour.styles.primaryColor}
              yPosition={yPosition}
              setYPosition={this.setYPosition}
              tourStops={tourStops}
              activeStop={index}
              starter={starter}
              setRestPosition={this.setRestPosition}
              restPosition={restPosition}
            >
              <StopGallery
                tourName={currentTour.name}
                tourDescription={currentTour.description}
                tourStops={tourStops}
                activeStop={index}
                gaEvent={this.changeStop}
                yPosition={yPosition}
                restPosition={restPosition}
                setYPosition={this.setYPosition}
                tourId={tourId}
                aid={aid}
              />
            </Drawer>
            {shareModal}
            <TrialTierBanner
              tier={tier}
              publicTour={publicTour}
              aid={aid}
              toggleC3DDescription={this.toggleC3DDescription}
              viewC3DDescription={viewC3DDescription}
            />
            {!isMobile && <Footer variant="desktop" />}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default ViewWrapper;
